<template>
    <h4>{{ $t(title) }}</h4>
</template>
<script>
export default{
    props: {
        title: {String}
    }
}
</script>